import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'lodash';

import { getItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME } from 'src/reducers/users/withholdingReport';
import ActionButton from 'jbc-front/components/ActionButton';
import { PdfFile } from 'jbc-front/components/icons';
import { serializeHttpGetParams } from 'src/utils/Http';
import { USER_PERSONAL_WITHHOLDING_REPORT } from 'src/constants/EndpointUrls';
import { formatDate } from 'src/utils/Date';

import SelectIssuedDateModal from 'src/features/YearEndReportWithholdingReports/components/SelectIssuedDateModal';

const WithholdingReportTable = ({ employee = {} }) => {
  const { t } = useTranslation();
  const [isIssueDateModalOpen, setIsIssueDateModalOpen] = useState(false);

  const showIssueDateModal = () => setIsIssueDateModalOpen(true);
  const hideIssueDateModal = () => setIsIssueDateModalOpen(false);

  const serializeParams = serializeHttpGetParams({ employee_ids: employee.id, year: employee.year });
  const pdfUrl = `${USER_PERSONAL_WITHHOLDING_REPORT}?${serializeParams}`;

  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list">
        <thead>
          <tr>
            <th>{t('features.Users.components.WithholdingReportTable.office')}</th>
            <th>{t('features.Users.components.WithholdingReportTable.year')}</th>
            <th>{t('features.Users.components.WithholdingReportTable.retired_date')}</th>
            <th>{t('features.Users.components.WithholdingReportTable.pdf')}</th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(employee) ? (
            <tr>
              <td>{employee.office}</td>
              <td>{employee.year}</td>
              <td>{formatDate(employee.resignedOn)}</td>
              <td>
                <ActionButton primary icon={<PdfFile size={18} />} onClick={showIssueDateModal}>
                  PDF
                </ActionButton>
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan={4}>{t('features.Users.components.WithholdingReportTable.data_not_found')}</td>
            </tr>
          )}
        </tbody>
      </table>
      <SelectIssuedDateModal isOpen={isIssueDateModalOpen} hideModal={hideIssueDateModal} url={pdfUrl} />
    </div>
  );
};

const mapStateToProps = state => ({
  employee: getItem(REDUCER_NAME, state)
});

export default connect(mapStateToProps)(WithholdingReportTable);
